if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          bullets: this.querySelector(".thumbs-bullets"),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (this.elements.bullets) {
          this.elements.bullets
            .querySelectorAll(".bullet-item")
            .forEach((bulletToSwitch) => {
              bulletToSwitch.addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  bulletToSwitch.dataset.mediaId,
                  false
                )
              );
            });
        }
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        let activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (!activeMedia) {
          this.elements.bullets
            .querySelectorAll(".bullet-item")
            .forEach((bullet) => {
              if (bullet.dataset.mediaId == mediaId) {
                activeMedia = bullet;
              }
            });
        }
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === "stacked"
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        const activeBullet = this.elements.bullets.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.setActiveBullet(activeBullet.dataset.mediaPosition);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      setActiveBullet(bullet) {
        if (!this.elements.bullets || !bullet) return;
        let mediaId;

        this.elements.bullets
          .querySelectorAll(".bullet-item")
          .forEach((element) => {
            element.removeAttribute("aria-current");
            element.classList.remove("active");
            if (element.dataset.mediaPosition == bullet) {
              element.setAttribute("aria-current", true);
              element.classList.add("active");
              mediaId = element.dataset.target;
            }
          });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}

// if (!customElements.get("media-gallery")) {
//   customElements.define(
//     "media-gallery",
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//           bullets: this.querySelector(".thumbs-bullets"),
//         };
//         this.mql = window.matchMedia("(min-width: 750px)");
//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener(
//           "slideChanged",
//           debounce(this.onSlideChanged.bind(this), 500)
//         );
//         this.elements.thumbnails
//           .querySelectorAll("[data-target]")
//           .forEach((mediaToSwitch) => {
//             mediaToSwitch
//               .querySelector("button")
//               .addEventListener(
//                 "click",
//                 this.setActiveMedia.bind(
//                   this,
//                   mediaToSwitch.dataset.target,
//                   false
//                 )
//               );
//           });
//         if (this.elements.bullets) {
//           this.elements.bullets
//             .querySelectorAll(".bullet-item")
//             .forEach((bulletToSwitch) => {
//               bulletToSwitch.addEventListener(
//                 "click",
//                 this.setActiveMedia.bind(
//                   this,
//                   bulletToSwitch.dataset.mediaId,
//                   false
//                 )
//               );
//             });
//         }
//         if (
//           this.dataset.desktopLayout.includes("thumbnail") &&
//           this.mql.matches
//         )
//           this.removeListSemantic();

//         this.setupScrollListener();
//       }

//       setupScrollListener() {
//         const slider = document.querySelector(".slider--mobile");
//         const slides = slider.children;
//         const thumbnailList = this.elements.thumbnails;

//         slider.addEventListener("scroll", () => {
//           clearTimeout(slider.scrollTimeout);
//           slider.scrollTimeout = setTimeout(() => {
//             const sliderRect = slider.getBoundingClientRect();
//             const visibleSlides = Array.from(slides).filter((slide) => {
//               const slideRect = slide.getBoundingClientRect();
//               return (
//                 slideRect.left >= sliderRect.left &&
//                 slideRect.right <= sliderRect.right
//               );
//             });

//             if (visibleSlides.length > 0) {
//               const firstVisibleSlide = visibleSlides[0];
//               const idParts = firstVisibleSlide.id.split("-");
//               const uniqueId = idParts[idParts.length - 1];
//               const targetElement = thumbnailList.querySelector(
//                 `[data-target$="${uniqueId}"]`
//               );

//               const allButtons = thumbnailList.querySelectorAll(
//                 'button[aria-current="true"]'
//               );
//               allButtons.forEach((button) =>
//                 button.removeAttribute("aria-current")
//               );

//               if (targetElement) {
//                 const button = targetElement.querySelector("button");
//                 if (button) {
//                   button.setAttribute("aria-current", "true");
//                 } else {
//                   console.log("Button not found inside target element.");
//                 }

//                 targetElement.scrollIntoView({
//                   behavior: "smooth",
//                   block: "nearest",
//                   inline: "center",
//                 });
//               }
//             }
//           }, 100);
//         });
//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);
//       }

//       setActiveMedia(mediaId, prepend) {
//         let activeMedia = this.elements.viewer.querySelector(
//           `[data-media-id="${mediaId}"]`
//         );
//         if (!activeMedia) {
//           this.elements.bullets
//             .querySelectorAll(".bullet-item")
//             .forEach((bullet) => {
//               if (bullet.dataset.mediaId == mediaId) {
//                 activeMedia = bullet;
//               }
//             });
//         }
//         this.elements.viewer
//           .querySelectorAll("[data-media-id]")
//           .forEach((element) => {
//             element.classList.remove("is-active");
//           });
//         activeMedia.classList.add("is-active");

//         if (prepend) {
//           activeMedia.parentElement.prepend(activeMedia);
//           if (this.elements.thumbnails) {
//             const activeThumbnail = this.elements.thumbnails.querySelector(
//               `[data-target="${mediaId}"]`
//             );
//             activeThumbnail.parentElement.prepend(activeThumbnail);
//           }
//           if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//         }

//         this.preventStickyHeader();
//         window.setTimeout(() => {
//           if (this.elements.thumbnails) {
//             activeMedia.parentElement.scrollTo({
//               left: activeMedia.offsetLeft,
//             });
//           }
//           if (
//             !this.elements.thumbnails ||
//             this.dataset.desktopLayout === "stacked"
//           ) {
//             activeMedia.scrollIntoView({ behavior: "smooth" });
//           }
//         });
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${mediaId}"]`
//         );
//         const activeBullet = this.elements.bullets.querySelector(
//           `[data-target="${mediaId}"]`
//         );
//         this.setActiveThumbnail(activeThumbnail);
//         this.setActiveBullet(activeBullet.dataset.mediaPosition);
//         this.announceLiveRegion(
//           activeMedia,
//           activeThumbnail.dataset.mediaPosition
//         );
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll("button")
//           .forEach((element) => element.removeAttribute("aria-current"));
//         thumbnail.querySelector("button").setAttribute("aria-current", true);
//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         this.elements.thumbnails.slider.scrollTo({
//           left: thumbnail.offsetLeft,
//         });
//       }

//       setActiveBullet(bullet) {
//         if (!this.elements.bullets || !bullet) return;
//         let mediaId;

//         this.elements.bullets
//           .querySelectorAll(".bullet-item")
//           .forEach((element) => {
//             element.removeAttribute("aria-current");
//             element.classList.remove("active");
//             if (element.dataset.mediaPosition == bullet) {
//               element.setAttribute("aria-current", true);
//               element.classList.add("active");
//               mediaId = element.dataset.target;
//             }
//           });
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector(
//           ".product__modal-opener--image img"
//         );
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute("aria-hidden", false);
//           this.elements.liveRegion.innerHTML =
//             window.accessibilityStrings.imageAvailable.replace(
//               "[index]",
//               position
//             );
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute("aria-hidden", true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();
//         const deferredMedia = activeItem.querySelector(".deferred-media");
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader =
//           this.stickyHeader || document.querySelector("sticky-header");
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute("role", "presentation");
//         this.elements.viewer.sliderItems.forEach((slide) =>
//           slide.setAttribute("role", "presentation")
//         );
//       }
//     }
//   );
// }
